import React from "react";

function openPDF(PDF){
  console.log(PDF)
  window.open(PDF,'_blank')
}

function DocumentButton(props) {
  return (
    <div class = "mt-3">
      <button onClick = {()=> openPDF(props.data)} type="button" class="btn btn-light btn-lg">{props.label} {props.semester}</button>
    </div>
  );
}

export default DocumentButton;